import type { ReactNode } from "react";

interface DashboardHeaderProps {
  title: string;
  subtitle?: string;
  /** Rendered on the right, aligned with the title row (e.g. jurisdiction / license type filters). */
  action?: ReactNode;
}

export function DashboardHeader({
  title,
  subtitle,
  action,
}: DashboardHeaderProps) {
  return (
    <div className="flex shrink-0 flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
        {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
      </div>
      {action != null && <div className="flex flex-shrink-0">{action}</div>}
    </div>
  );
}
